(function () {
// main.js - Gestione del tema e interazioni
// Classe per gestire il tema
function $d9293ff4b5d44d29$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $01e3e45ad8a96200$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $01e3e45ad8a96200$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $01e3e45ad8a96200$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $01e3e45ad8a96200$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


var $f59d652e391aa219$var$ThemeManager = /*#__PURE__*/ function() {
    "use strict";
    function ThemeManager() {
        (0, $d9293ff4b5d44d29$export$71511d61b312f219)(this, ThemeManager);
        this.themeToggle = document.getElementById('themeToggle');
        this.themeIcon = this.themeToggle.querySelector('.theme-toggle__icon');
        this.currentTheme = localStorage.getItem('theme') || 'dark';
        this.init();
    }
    (0, $01e3e45ad8a96200$export$71511d61b312f219)(ThemeManager, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                // Imposta il tema iniziale
                this.setTheme(this.currentTheme);
                // Event listener per il toggle
                this.themeToggle.addEventListener('click', function() {
                    return _this.toggleTheme();
                });
            }
        },
        {
            key: "setTheme",
            value: function setTheme(theme) {
                document.body.setAttribute('data-theme', theme);
                this.currentTheme = theme;
                // Aggiorna l'icona
                this.themeIcon.textContent = theme === 'dark' ? "\u2600\uFE0F" : "\uD83C\uDF19";
                // Salva la preferenza
                localStorage.setItem('theme', theme);
            }
        },
        {
            key: "toggleTheme",
            value: function toggleTheme() {
                var newTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
                this.setTheme(newTheme);
            }
        }
    ]);
    return ThemeManager;
}();
// Classe per animazioni scroll
var $f59d652e391aa219$var$ScrollAnimations = /*#__PURE__*/ function() {
    "use strict";
    function ScrollAnimations() {
        (0, $d9293ff4b5d44d29$export$71511d61b312f219)(this, ScrollAnimations);
        this.header = document.querySelector('.header');
        this.init();
    }
    (0, $01e3e45ad8a96200$export$71511d61b312f219)(ScrollAnimations, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                // Header scroll effect
                window.addEventListener('scroll', function() {
                    return _this.handleScroll();
                });
                // Smooth scroll per i link di navigazione
                this.setupSmoothScroll();
            }
        },
        {
            key: "handleScroll",
            value: function handleScroll() {
                if (window.scrollY > 50) this.header.classList.add('header--scrolled');
                else this.header.classList.remove('header--scrolled');
            }
        },
        {
            key: "setupSmoothScroll",
            value: function setupSmoothScroll() {
                var links = document.querySelectorAll('a[href^="#"]');
                links.forEach(function(link) {
                    link.addEventListener('click', function(e) {
                        e.preventDefault();
                        var targetId = link.getAttribute('href');
                        if (targetId === '#') return;
                        var target = document.querySelector(targetId);
                        if (target) {
                            var offsetTop = target.offsetTop - 80; // Offset per l'header fisso
                            window.scrollTo({
                                top: offsetTop,
                                behavior: 'smooth'
                            });
                        }
                    });
                });
            }
        }
    ]);
    return ScrollAnimations;
}();
// Inizializzazione quando il DOM è pronto
document.addEventListener('DOMContentLoaded', function() {
    new $f59d652e391aa219$var$ThemeManager();
    new $f59d652e391aa219$var$ScrollAnimations();
    console.log("Portfolio Mayara Amaral caricato con successo! \uD83D\uDE80");
});

})();
//# sourceMappingURL=path0.2ff32410.js.map
